import { userTypes } from 'app/shared/enum/userTypes.enum';
import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[isAdmin]'
})
export class IsAdminDirective {


  constructor( private elementRef: ElementRef) { }

  ngOnInit() {

      if (localStorage.getItem('type') == userTypes.Admin) {
        this.isAllow(true);
      } else {
        this.isAllow(false);
      }
  }



  isAllow(allow: boolean) {
    const el: HTMLElement = this.elementRef.nativeElement;

    if (!allow) {
      el.remove();
    }
  }
}
